export default __webpack_public_path__ + "static/media/question-mark-square.596de363.png";